import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Analytics } from '../../components';

export class AnalyticsTab extends Component {
  render() {
    return (
      <div>
        <Analytics {...this.props} />
      </div>
    );
  }
}

AnalyticsTab.propTypes = {
  location: PropTypes.object
};

export default injectIntl(AnalyticsTab);
